import CoaModel from '../coa/coa-model';

export default class CoabalanceModel {
    id: number;
    balancedate: string;
    value: number;
    coa: any;
    coaCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.balancedate = datarow.balancedate;
        this.value = datarow.value;
        let coa = datarow.coa?.data? new CoaModel(datarow.coa?.data) : datarow.coa;
        this.coa = coa?.id;
        this.coaCaption = coa.name; 
        
    } 

    public static endPoint: string = 'coa-balances';
    public static endPointFilterList = (coaId?: number) => {
        return '?populate=*&sort[balancedate]=desc&filters[coa]=' + coaId;
    }
    public static url: string = '/coabalance';
    public static caption: string = 'Balance Detail';

    public static defaultValue = () => {
        return {
        id: 0,
        balancedate: '',
        value: 0,
        coa: null,
        coaCaption: '',

  
        }
    }
    
    public static columns = [
        { name: 'balancedate', caption: 'Period' },
        { name: 'value', caption: 'Value', type: 'money' },
    ]

    public static columnPicklist = [
        { name: 'balancedate', caption: 'Period' },
        { name: 'value', caption: 'Value', type: 'money' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
        
}